module.exports = __webpack_public_path__ + "img/logo.73c8ecdb.png";